export const MONTHS = [
  "Styczeń",
  "Luty",
  "Marzec",
  "Kwiecień",
  "Maj",
  "Czerwiec",
  "Lipiec",
  "Sierpień",
  "Wrzesień",
  "Październik",
  "Listopad",
  "Grudzień",
];

export function integerParam(
  value: string | null,
  min: number,
  max: number,
): number | undefined {
  if (!value || !/^\d+$/.test(value)) return undefined;
  const number = Number(value);
  return number >= min && number <= max ? number : undefined;
}

export function readPeriod(
  params: URLSearchParams,
  currentYear = new Date().getFullYear(),
) {
  const year =
    params.get("year") === "all"
      ? undefined
      : (integerParam(params.get("year"), 1900, 2100) ?? currentYear);
  const month =
    year === undefined ? undefined : integerParam(params.get("month"), 1, 12);
  return { year, month };
}

export function shiftMonth(year: number, month: number, delta: number) {
  const index = year * 12 + month - 1 + delta;
  return {
    year: Math.floor(index / 12),
    month: (((index % 12) + 12) % 12) + 1,
  };
}

export function periodLabel(year?: number, month?: number) {
  return year === undefined
    ? "Wszystkie lata"
    : month
      ? `${MONTHS[month - 1]} ${year}`
      : `Rok ${year}`;
}

export function formatMinutes(value: number | null | undefined) {
  if (value == null || value <= 0) return "Brak danych o czasie";
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  return hours
    ? `${hours} godz.${minutes ? ` ${minutes} min` : ""}`
    : `${minutes} min`;
}

export function formatDate(value: string | null) {
  if (!value) return "Brak daty";
  const date = new Date(`${value.slice(0, 10)}T12:00:00`);
  return Number.isNaN(date.getTime())
    ? "Brak daty"
    : date.toLocaleDateString("pl-PL", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
}
